<div class="modal-comparar-atos">
    <div class="modal-block">
        <div class="modal-content" *ngIf="conteudoAtoBase && conteudoAtoBase.length > 0 && exibirComparacao">
            <div class="modal-header">
                <h4 class="modal-title pull-left">
                    Comparar atos
                </h4>
            </div>
            <div class="row" style="padding: 15px 0px 5px 15px;">
                <div class="col-sm-6">
                    <span class="titulo-comparacao">Ato {{ idAtoBase }} (visão original)</span>
                </div>
                <div class="col-sm-6">
                    <span *ngIf="!idAtoCorrecao || idAtoCorrecao === 0" class="titulo-comparacao">Novo ato</span>
                    <span *ngIf="idAtoCorrecao && idAtoCorrecao !== 0" class="titulo-comparacao">Ato {{ idAtoCorrecao }} (visão original)</span>
                </div>
            </div>
            <div class="modal-body" style="padding-top: 5px;">
                <div>
                    <app-visualizar-diferencas 
                        [idAtoBase]="idAtoBase"
                        [conteudoEsquerda]="conteudoAtoBase" 
                        [conteudoDireita]="conteudoAto">
                    </app-visualizar-diferencas>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" *ngIf="!idAtoCorrecao || idAtoCorrecao === 0" 
                    (click)="fecharModalEIncluirAssimMesmo()">Incluir assim mesmo</button>
                <button type="button" class="btn btn-default" (click)="fecharModalEConverterPubRepetida()">Converter em publicação repetida</button>
                <button type="button" class="btn btn-default" (click)="fecharModalERepublicar()" [disabled]="naoPermiteRepublicacao">Republicar ato</button>
                <button id="btnFecharModalComparacao" type="button" class="btn btn-primary" (click)="fecharModal()" #btnFecharModalComparacao>Fechar</button>
            </div>
        </div>
    </div>
</div>